import React, {useEffect} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles} from "@material-ui/core";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import NewBRValidationForm from "./NewBRValidationForm";
import BBIconCheck from "../../../assets/bbCustomIcons/BBIconCheck";
import {useSelector} from "react-redux";

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const FormDialog = (props) => {

    const {iconOnly = false, targetEntityId = null, buttonLabel="Attestation", portfolioView=false} = props;
    const {didJustCreateNewValidation} = useSelector(({breachrisk}) => breachrisk.appMisc);

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if(didJustCreateNewValidation) {
            handleClose();
        }
    }, [didJustCreateNewValidation]);

    const DialogTitle = withStyles(styles)((props) => {
        const { children, classes, onClose, ...other } = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    return (
        <div>
            <Tooltip title={"Attestation provides more accurate scores."}>
                <Button
                    // id={"newAttestationButton"}
                    variant="outlined"
                    color="default"
                    onClick={handleClickOpen}
                    className={"text-electric-blue tourNewAttestationButton"}
                >
                    {iconOnly
                        ? <BBIconCheck style={{fontSize: "70px"}}/>
                        : <><BBIconCheck className={"mr-2"}/>New {buttonLabel}</>
                    }

                </Button>
            </Tooltip>

            <Dialog
                id={"NewBRValidationDialog"}
                fullWidth={false}
                maxWidth={"xl"}
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    New Attestation
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        This feature is for IT directors or those in your company with the best understanding of your IT assets. Attest that we see your entire public-facing IT infrastructure in order to increase the fidelity of your BreachRisk™ Score and BreachRisk™ Report.
                    </DialogContentText>
                    {/*<TextField*/}
                    {/*    autoFocus*/}
                    {/*    margin="dense"*/}
                    {/*    id="name"*/}
                    {/*    label="Email Address"*/}
                    {/*    type="email"*/}
                    {/*    fullWidth*/}
                    {/*/>*/}
                    <div className={"border-2 p-3"}>
                        <NewBRValidationForm portfolioView={portfolioView}
                                             targetEntityId={targetEntityId}/>
                    </div>

                </DialogContent>
                <DialogActions>
                    {/*<Button onClick={handleClose} color="primary">*/}
                    {/*    Cancel*/}
                    {/*</Button>*/}
                    <Button id={"CloseBRNewValidationDialog"} onClick={handleClose} color="primary">
                        Done
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default FormDialog;
